<div class="dashboard-youtube-dialog">
  <dashboard-dialog-title [title]="'YouTube Tutorials'"></dashboard-dialog-title>
  <mat-dialog-content class="dashboard-youtube-dialog__content">
    <p>See below the tutorials, if you have a particular question or you wish to request support
      please contact us at <a href="mailto:dashboard-bms@utwente.nl" target="_blank">dashboard-bms@utwente.nl</a></p>
    <dashboard-loader *ngIf="!youtubeVideosReady" [title]="'Loading Youtube Tutorials...'"></dashboard-loader>
    <div *ngIf="youtubeVideosReady">
      <div
        *ngFor="let video of this.youTubeVideos"
        class="dashboard-youtube-dialog__content-list-video"
        fxLayout="row"
        fxLayoutGap="10px"
      >
        <a [href]="video?.videoLink" target="_blank">
          <img [src]="video?.thumbnailSmall" />
        </a>
        <div fxLayout="column">
          <a [href]="video?.videoLink" target="_blank" class="dashboard-youtube-dialog__content-list-video-title">
            {{ video?.videoTitle }}
          </a>
          {{ video?.channelTitle }}
        </div>
      </div>
    </div>
  </mat-dialog-content>
</div>
